if (!customElements.get('klaim-cart-discount')) {
  class KlaimCartDiscount extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.klaim-cart-discount__form');
      this.input = this.querySelector('.klaim-cart-discount__input');
      this.button = this.querySelector('.klaim-cart-discount__button');
      this.status = this.querySelector('.klaim-cart-discount__status');

      if (!this.form || !this.input || !this.button || !this.status) return;

      const savedCode = window.sessionStorage.getItem('klaim-cart-discount-code');
      if (savedCode) {
        this.input.value = savedCode;
      }

      if (window.sessionStorage.getItem('klaim-cart-discount-applied') === savedCode && savedCode) {
        this.setStatus('CODE RECEIVED. FINAL TOTAL UPDATES AT CHECKOUT.');
      }

      this.form.addEventListener('submit', this.handleSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
    }

    handleSubmit = (event) => {
      event.preventDefault();

      const code = this.input.value.trim();
      if (!code) {
        this.setStatus('ENTER A DISCOUNT CODE.', true);
        this.input.focus();
        return;
      }

      window.sessionStorage.setItem('klaim-cart-discount-code', code);
      window.sessionStorage.setItem('klaim-cart-discount-applied', code);
      window.sessionStorage.setItem('klaim-cart-discount-reopen', 'true');

      this.button.disabled = true;
      this.button.textContent = 'APPLYING';
      this.setStatus('APPLYING CODE...');

      const shopRoot = window.Shopify?.routes?.root || '/';
      const normalizedRoot = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const redirectPath = `${window.location.pathname}${window.location.search}`;

      window.location.assign(
        `${normalizedRoot}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirectPath)}`
      );
    };

    setStatus(message, isError = false) {
      this.status.textContent = message;
      this.status.classList.toggle('is-error', isError);
    }
  }

  customElements.define('klaim-cart-discount', KlaimCartDiscount);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.sessionStorage.getItem('klaim-cart-discount-reopen') !== 'true') return;

  window.sessionStorage.removeItem('klaim-cart-discount-reopen');
  window.requestAnimationFrame(() => document.querySelector('cart-drawer')?.open());
});
